<div class="card" [ngClass]="this.active ? 'active' : ''" (click)="this.active ? '' : SelectIndicator(this.properties)">
  <div class="content">
    <div class="title">
      <div class="color" [ngStyle]="{'border-radius': '1000px',
                'background-color': (properties.color) ?? 'transparent',
                'height'          : '.4rem',
                'width'           : '.4rem'}"></div>
      <!-- <span class="title"> {{this.properties.indicatorName}} </span> -->
      <span class="title"> {{this.properties.indicatorCode}} </span>
    </div>

    <div class="content">
      <span *ngIf="properties.value >= 0;else notValue">
        {{this.properties.value | number:'1.2-2'}}
      </span>
      <ng-template #notValue>
        <span>
          -,--
        </span>
      </ng-template>
    </div>

    <div class="Footer">
      <span style="font-size: 9px;">
        {{this.properties.measurementUnit}}
      </span>
    </div>
  </div>

</div>
